import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "concepts"
    }}>{`Concepts`}</h1>
    <p>{`Before you start developing plugins for InDesign, it's important to understand the basic concepts of InDesign plugin architecture. This section will introduce you to some of the most important concepts like entrypoints and the manifest file.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      